<script setup>
defineProps({ fill: String });
</script>
<template>
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 5H1.5M1.5 5L5 8.5M1.5 5L5 1.5"
      :fill="fill ? fill : '#fff'"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
